import React from "react";
import { createTypographyHelper } from "../../../../utils/typography";
import { useTranslation } from "react-i18next";

const DisclaimerSection = ({ getTypographyClass }) => {
    const { t } = useTranslation();
    const disclaimer = t(
        "editBooking.BookingEditPage.disclaimer.content",
        { returnObjects: true }
    );

    const disclaimerList = Array.isArray(disclaimer) ? disclaimer : [disclaimer];
    return (
        <section className="tw:mb-4 tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:flex tw:flex-col tw:gap-6 tw:p-5">
            <div className={`tw:text-[#212529] ${getTypographyClass(14)}`}>
                {t("editBooking.BookingEditPage.disclaimer.title")}
            </div>
            <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
            <div className={`tw:text-[#4e4e4e] tw:leading-[20px] ${getTypographyClass(13)}`}>
                {disclaimerList.map((val, ind) => (
                    <div key={ind}>
                        {ind > 0 && (
                            <div className="tw:mb-1">&nbsp;</div>
                        )}
                        <div className="tw:mb-1">
                            {val}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default DisclaimerSection;
